import LeftArrow from "../../public/assets/pagination-left-arrow.svg";
import RightArrow from "../../public/assets/pagination-right-arrow.svg";
import styles from "../../styles/customPagination.module.scss";
import React, { useState } from "react";

export default function CustomPagination({
  totalPages,
  handleChangePage,
  className,
}: {
  totalPages: number;
  handleChangePage: (currentPage: number) => void;
  className?: string;
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const showCurrentPage =
    currentPage > 2 && currentPage < totalPages - 1 ? true : false;
  const showSecondPage = totalPages > 2 ? true : false;
  const showSecondToLastPage = totalPages >= 4 ? true : false;
  const showLastPage = totalPages >= 2 ? true : false;
  const showLeftArrow = currentPage == 1 ? false : true;
  const showRightArrow = currentPage == totalPages ? false : true;
  const showFirstDot =
    totalPages > 4 && (currentPage - 1 > 2 || currentPage <= 2);
  const showSecondDot = currentPage + 1 < totalPages - 1 && currentPage > 2;

  function isActiveStyle(pageNumber: number): string {
    return currentPage == pageNumber ? styles.active : styles.page;
  }

  function changePage(newPage: number) {
    setCurrentPage(newPage);
    handleChangePage(newPage);
  }

  return (
    <div className={`${styles.main} ${className}`}>
      {showLeftArrow && (
        <LeftArrow
          className={styles.arrow}
          onClick={() => changePage(currentPage - 1)}
        ></LeftArrow>
      )}
      <div className={isActiveStyle(1)} onClick={() => changePage(1)}>
        1
      </div>
      {showSecondPage && (
        <div className={isActiveStyle(2)} onClick={() => changePage(2)}>
          2
        </div>
      )}
      {showFirstDot && <div className={styles.dot}>. . .</div>}
      {showCurrentPage && <div className={styles.active}>{currentPage}</div>}
      {showSecondDot && <div className={styles.dot}>. . .</div>}
      {showSecondToLastPage && (
        <div
          className={isActiveStyle(totalPages - 1)}
          onClick={() => changePage(totalPages - 1)}
        >
          {totalPages - 1}
        </div>
      )}
      {showLastPage && (
        <div
          className={isActiveStyle(totalPages)}
          onClick={() => changePage(totalPages)}
        >
          {totalPages}
        </div>
      )}
      {showRightArrow && (
        <RightArrow
          className={styles.arrow}
          onClick={() => changePage(currentPage + 1)}
        ></RightArrow>
      )}
    </div>
  );
}
